// React and related libraries
import React, { useState, useEffect, useRef, useMemo } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "lodash";
import axios from "axios";
// import 'swiper/swiper-bundle.min.css';
import Rating from "react-rating";
import more from "../../../Assets/Icons/more2.png";
import LeoImg from "./../../../Assets/Image/Leo.png";
import ReactPaginate from "react-paginate";

// Component imports
import { Swiper, SwiperSlide } from "swiper/react";
import Navbar from "../../Navbar/Navbar";
import 'swiper/css';

import Test3 from "../../Test3";
import Product from "../ProductComponents/ProductCard";
import FilterBar from "../../Restaurant/MenuSelection/FilterBar/FilterBar";
import PaginatedItems from "./SearchPagination";
import RestaurantCard from "../RestaurantComponents/RestaurantCard";
import { Pagination, Navigation, FreeMode } from "swiper";

// Bootstrap and CSS
import "./SearchResult.css";
import { Modal, Tab, Nav, Button } from "react-bootstrap";

// Utility and State Management
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";

// Asset imports
import loadingGif from "./../../../Assets/Image/loading.gif";
import FoodCard from "../../Home/FoodSelection/FoodCard";
import backLeft from "../../../Assets/Icons/left.png";
import backRight from "../../../Assets/Icons/Nextx.png";
import { sliceText } from "../../../utils/sliceText";

import backBtn from "./../../../Assets/Icons/back.png";
import logo from "./../../../Assets/Image/LogoTransparent.png";
import searchIcont from "./../../../Assets/Icons/searchIcon2.png";
import searchIcontCoffee from "./../../../Assets/Icons/searchIcon.png";
import searchair from "./../../../Assets/Image/SearchAir.png";
import loginImg from "./../../../Assets/Image/login.png";
import loginDesktopImg from "./../../../Assets/Image/login-Desktop.png";
import homeImg from "./../../../Assets/Image/home.png";
import menuImg from "./../../../Assets/Image/menu.png";
import leo from "./../../../Assets/Image/Leo.png";
import fuchka from "./../../../Assets/Image/1 51.png";
import star from "./../../../Assets/Icons/starCoffe.png";
import PKB from "./../../../Assets/Image/PKB.png";
import pasta from "./../../../Assets/Image/Pasta 1.png";
import search from "./../../../Assets/Icons/searchIcon.png";
import remove from "../../../Assets/Icons/remove.png";
import useIsMobile from "../../../hooks/useIsMobile";
import Footer from "../../../components/Footer/Footer";

// Commented import (Review if needed)
// import Cart from '../Cart/Cart';

function SearchResult(props) {
  const location = useLocation();
  const propsData = location.state;
  const apiAddress = process.env.REACT_APP_SECRET;
  // Carousel and Scroll Handling
  const myRef = useRef();
  const [intersecting, setIntersecting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const searchDialogdivRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(1);
  // State for search section
  const [SearchData, setSearchData] = useState({ searchDataList: [], totalCount: 0, });
  const [isLoading, setIsLoading] = useState(false);
  const [dataCollections, setDataCollections] = useState([]);
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [clickedFilterId, setClickedFilterId] = useState(null);
  const [scrollingDown, setScrollingDown] = useState(false);
  const [scrollingUp, setScrollingUp] = useState(false);
  const [filters, setFilters] = useState([]);

  //#region Swiper Navigation Button functionality
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  const handleSlideChange = (swiper) => {
    if (swiper.isEnd) {
      setShowNext(false);
    } else {
      setShowNext(true);
    }

    if (swiper.isBeginning) {
      setShowPrev(false);
    } else {
      setShowPrev(true);
    }
  };

  const HandleSliderChange2 = (swiper) => {
    if (swiper.isEnd) {
      // setShowNext(false);
    } else {
      setShowNext(true);
    }
  };

  useEffect(() => {
    const content = document.querySelector('.swiper-horizontal');
    if (content) {
      const isScrollable = content.scrollWidth > content.clientWidth;
      if (isScrollable) { setShowNext(true); }
    }
  }, [filters]);

  //#endregion

  // Fetch data on component mount
  useEffect(() => {
    axios
      .get(`${apiAddress}/api/FoodCategory/getFoodCategory`)
      .then((response) => {
        console.log("data from id: ", response.data);
        setDataCollections(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [apiAddress]);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  // Fetch search data with pagination
  const GetSearchDataPaged = async (pageNo, pageSize, initial = false) => {
    // setIsLoading(true);
    await axios
      .get(
        `${apiAddress}/api/Search/GetSearchDataPagedAsync?searchStr=${propsData}&pageNo=${pageNo}&pageSize=${pageSize}`
      )
      .then((response) => {
        // setSearchData((prev) => ({
        //   searchDataList: [
        //     ...prev.searchDataList,
        //     ...response.data.searchDataList,
        //   ],
        //   totalCount: response.data.totalCount,
        // }));
        setSearchData((prevData) => ({
          searchDataList: initial
            ? response.data.searchDataList
            : [...prevData.searchDataList, ...response.data.searchDataList],
          totalCount: response.data.totalCount,
        }));
        setIsLoading(false);
      });
    if (!initial) {
      setPageNumber(pageNumber + 1);
    }
  };

  useMemo(() => {
    if (SearchData.searchDataList.length > 0) {
      // const sections = SearchData.searchDataList.map((item) => ({
      //   id: item.keywordId,
      //   keyword: item.foodKeyword,
      //   keywordImage: item.keywordImage,
      // }));

      // const subSection = SearchData.searchDataList.map((item) => ({
      //   id: item.keywordTagId,
      //   keyword: item.keywordtag,
      //   keywordImage: item.keywordTagImage,
      // }));

      const sections = SearchData.searchDataList.flatMap((item) => {
        const ids = item.keywordId?.split(",").map((id) => id.trim()) || [];
        const keywords = item.foodKeyword?.split(",").map((kw) => kw.trim()) || [];
        const images = item.keywordImage?.split(",").map((img) => img.trim()) || [];

        return ids.map((id, index) => ({
          id,
          keyword: keywords[index] || "", // Ensure safe access
          keywordImage: images[index] || "", // Ensure safe access
        }));
      });

      const subSection = SearchData.searchDataList.flatMap((item) => {
        const ids = item.keywordTagId?.split(",").map((id) => id.trim()) || [];
        const keywords = item.keywordtag?.split(",").map((kw) => kw.trim()) || [];
        const images = item.keywordTagImage?.split(",").map((img) => img.trim()) || [];

        return ids.map((id, index) => ({
          id,
          keyword: keywords[index] || "",
          keywordImage: images[index] || "",
        }));
      });

      const allFilters = sections.concat(subSection);
      const newFilters = allFilters.filter((item) => item.id !== null && item.id !== "");

      const uniqueFilters = newFilters.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id
        ))
      );

      setFilters(uniqueFilters); // Update filters with the new list
    }





  }, [SearchData.searchDataList]);

  // Initial fetch of search data
  useEffect(() => {
    GetSearchDataPaged(1, 7, true);
  }, [propsData]);

  // Handle click outside of search dialog to close modal
  const handleClickOutside = (event) => {
    if (
      searchDialogdivRef.current &&
      !searchDialogdivRef.current.contains(event.target)
    ) {
      setShowModal(false);
    }
  };

  // Add and remove event listener for clicks outside the modal
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Navbar related state and function
  const [blur, setBlur] = useState(false);
  const searchDialogOpen = (NavbarData) => {
    setBlur(NavbarData);
  };

  // Dummy or placeholder variables
  const dataSelectedKeyword = null;

  // Pagination test (commented-out)
  const itemsPerPage = 10;
  const pageCount = Math.ceil(SearchData.totalCount / itemsPerPage);
  const handlePageClick = (event) => {
    GetSearchDataPaged(propsData, event.selected + 1, 7);
  };

  // Automatic screen size calculation
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

  // const handleResize = () => {

  //   setScrollingDown(false);
  //   setScrollingUp(false);

  //   const contentFoodItem = document.getElementById("testContainerSearchResult");
  //   contentFoodItem.style.marginTop = "10px";

  //   setIsMobile(window.innerWidth < 760);
  // };

  // useEffect(() => {
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  const isMobile = useIsMobile(760);

  const handleClickFilter = (id) => {
    if (id === null) {
      // "All" filter clicked: reset to show all items
      setClickedFilterId(null);  // Deselect any filter
      setIsFilterClicked(false); // "All" filter selected
      setFilteredItems([]);      // Reset filtered items (show all)
    } else if (clickedFilterId === id) {
      // The same filter clicked again: deselect it and select "All"
      setClickedFilterId(null);  // Deselect the filter
      setIsFilterClicked(false); // Select "All"
      setFilteredItems([]);      // Reset filtered items (show all)
    } else {
      // New filter clicked: apply the filter and update state
      const filtered = SearchData.searchDataList.filter(
        (item) => item.keywordId.split(", ").includes(id) || item.keywordTagId.split(", ").includes(id)
      );
      setClickedFilterId(id); // Set the selected filter ID
      setIsFilterClicked(true); // Mark that a filter is active (not "All")
      setFilteredItems(filtered); // Apply the filtered items
    }
  }

  //#region Filter bar fixed at top while scrolling
  const contentRef = useRef(null);
  const contentFoodItemRef = useRef(null);
  let scrollingInProgress = false;

  // useEffect(() => {
  //   let lastScrollTop = 0;

  //   const handleScroll =
  //     // debounce(
  //     () => {
  //       // if (scrollingInProgress) return;
  //       scrollingInProgress = true;

  //       // requestAnimationFrame(() => {
  //       const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //       setScrollingDown(false);
  //       setScrollingUp(false);

  //       // const content = document.getElementById("FilterBarMainFood");
  //       // const contentFoodItem = document.getElementById("testContainerSearchResult");

  //       const content = contentRef.current;
  //       const contentFoodItem = contentFoodItemRef.current;

  //       if (content) {
  //         if (currentScrollTop > lastScrollTop) {
  //           // Scrolling down
  //           if (!isMobile) {
  //             setScrollingDown(true);
  //             setScrollingUp(false);
  //           } else if (isMobile) {
  //             setScrollingDown(false);
  //             setScrollingUp(false);

  //             contentFoodItem.style.marginTop = "0px";
  //           }
  //         } else {
  //           // Scrolling up
  //           setScrollingUp(true);
  //           setScrollingDown(false);

  //           contentFoodItem.style.marginTop = "180px";
  //         }
  //       }

  //       lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  //       scrollingInProgress = false;
  //       // });
  //     }

  //   // , 100);

  //   document.addEventListener("scroll", handleScroll);
  //   return () => {
  //     document.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);
  //#endregion

  const [showSlider, setShowSlider] = useState(true);
  const prevScrollY = useRef(0);

  useEffect(() => {
    // if (!isMobile) return; // Only run this effect on mobile

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setShowSlider(currentScrollY <= prevScrollY.current); // Hide on scroll up, show on scroll down
      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  return (
    <>
      {/* Header / Navbar */}
      <div style={{ background: "yellow" }}>
        <Navbar handleNavbar={searchDialogOpen} showSeeMore={false} />
      </div>

      {/* Filter-bar  */}
      {/* <div ref={contentRef} id="FilterBarMainFood" className={`${scrollingDown ? "positionfixedScrollDown" : ""} ${scrollingUp ? "positionfixedScrollUP" : ""} FoodSelection FilterBarMainFood pt-4 mt-4 mb-4`}>
        <div className={`g-4 mx-auto justify-content-center mt-5 selectionButton scrollbtnMobile  ${intersecting ? "HideSelectionSingleButton" : ""}`} ref={myRef} >
          <div className="slider-btn-wrapper">

            <button ref={prevRef} style={{ display: showPrev ? "" : "none" }} className="custom-prev-button prev-button">
              <img src={backLeft} alt="left icon" />
            </button>
            <button ref={nextRef} style={{ display: showNext ? "" : "none" }} className="custom-next-button next-button">
              <img src={backRight} alt="right icon" />
            </button>

            <Swiper
              spaceBetween={3}
              onSlideChange={(swiper) => handleSlideChange(swiper)}
              onSwiper={(swiper) => handleSlideChange(swiper)}
              modules={[Navigation, FreeMode]}
              freeMode={true}
              breakpoints={{
                300: {
                  slidesPerView: 3,
                  spaceBetween: 8,
                },
                350: {
                  slidesPerView: 3.5,
                  spaceBetween: 8,
                },
                450: {
                  slidesPerView: 4,
                  spaceBetween: 8,
                },
                640: {
                  slidesPerView: 6,
                  spaceBetween: 8,
                },
                768: {
                  slidesPerView: 7,
                  spaceBetween: 16,
                },
                1000: {
                  slidesPerView: 10,
                },
                1500: {
                  slidesPerView: 14,
                },
                // 700: {
                //   slidesPerView: 6,
                // },
              }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
            >
              <SwiperSlide
                className={`slider-content ${clickedFilterId === null ? "active-filter" : ""}`}
                onClick={() => handleClickFilter(null)} // Clicking "All" deselects any filter
              >
                <div className="keyword">
                  <div className="filter-img food-filter-image">
                    <img
                      src={"https://gotastelivestorage.blob.core.windows.net/gotasteimages/5f3632b2-78db-416c-a337-7af934c77e4f"}
                      alt="slider"
                    />
                  </div>
                  <p className="filter-name">All</p>
                </div>
              </SwiperSlide>

              {filters?.map((item, idx) => (
                <SwiperSlide
                  key={idx}
                  className={`slider-content ${clickedFilterId === item.id ? "active-filter" : ""}`}
                  onClick={() => handleClickFilter(item.id)} // Clicking a filter will either select or deselect it
                >
                  <div className="keyword">
                    <div className="filter-img food-filter-image">
                      <img
                        src={item.keywordImage ? item.keywordImage : "https://gotastelivestorage.blob.core.windows.net/gotasteimages/5f3632b2-78db-416c-a337-7af934c77e4f"}
                        alt="slider"
                      />
                    </div>
                    <p className="filter-name large-tooltip" title={item.keyword}>{sliceText(item.keyword, 7)}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div> */}

      <div className={`hide-unhide ${isMobile ? "mobile-margin" : showSlider ? "desktop-padding" : "dekstop-no-padding"} ${isMobile ? (showSlider ? "unhide" : "hide") : "unhide"}`}>
        <button ref={prevRef} style={{ display: showPrev ? "" : "none" }} className={`custom-prev-button prev-button ${showSlider && !isMobile ? "top-75" : "top-50"}`}>
          <img src={backLeft} alt="left icon" />
        </button>
        <button ref={nextRef} style={{ display: showNext ? "" : "none" }} className={`custom-next-button next-button ${showSlider && !isMobile ? "top-75" : "top-50"}`}>
          <img src={backRight} alt="right icon" />
        </button>

        <Swiper
          spaceBetween={3}
          onSlideChange={(swiper) => handleSlideChange(swiper)}
          onSwiper={(swiper) => handleSlideChange(swiper)}
          modules={[Navigation, FreeMode]}
          freeMode={true}
          breakpoints={{
            300: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            350: {
              slidesPerView: 3.5,
              spaceBetween: 8,
            },
            450: {
              slidesPerView: 4,
              spaceBetween: 8,
            },
            640: {
              slidesPerView: 6,
              spaceBetween: 8,
            },
            768: {
              slidesPerView: 7,
              spaceBetween: 16,
            },
            1000: {
              slidesPerView: 10,
            },
            1500: {
              slidesPerView: 14,
            },
            // 700: {
            //   slidesPerView: 6,
            // },
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
        >
          <SwiperSlide
            className={`slider-content ${clickedFilterId === null ? "active-filter" : ""}`}
            onClick={() => handleClickFilter(null)} // Clicking "All" deselects any filter
          >
            <div className="keyword">
              <div className="filter-img food-filter-image">
                <img
                  src={"https://gotastelivestorage.blob.core.windows.net/gotasteimages/5f3632b2-78db-416c-a337-7af934c77e4f"}
                  alt="slider"
                />
              </div>
              <p className="filter-name">All</p>
            </div>
          </SwiperSlide>

          {filters?.map((item, idx) => (
            <SwiperSlide
              key={idx}
              className={`slider-content ${clickedFilterId === item.id ? "active-filter" : ""}`}
              onClick={() => handleClickFilter(item.id)} // Clicking a filter will either select or deselect it
            >
              <div className="keyword">
                <div className="filter-img food-filter-image">
                  <img
                    src={item.keywordImage ? item.keywordImage : "https://gotastelivestorage.blob.core.windows.net/gotasteimages/5f3632b2-78db-416c-a337-7af934c77e4f"}
                    alt="slider"
                  />
                </div>
                <p className="filter-name large-tooltip" title={item.keyword}>{sliceText(item.keyword, 7)}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Showing food Items */}
      {isFilterClicked ?

        /** Filtered Items */
        filteredItems.length > 0 ?
          <div ref={contentFoodItemRef} id="testContainerSearchResult" style={{ transition: 'all 0.3s ease-in-out', minHeight: '800px', marginTop: "11em" }} className={`testContainer filter-result ${isMobile ? 'mx-0' : 'mx-4'}`}>
            {
              filteredItems?.map((item, idx) => <FoodCard key={idx} foodItemData={item}></FoodCard>)
            }
          </div>
          :
          <div ref={contentFoodItemRef} id="testContainerSearchResult">No food item available</div>
        :
        /** All Items */
        <div ref={contentFoodItemRef} id="testContainerSearchResult" style={{ transition: 'all 0.3s ease-in-out', minHeight: '800px', marginTop: "11em" }} className={`search-result-container ${blur ? "backgroundBlur" : ""}`}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "5rem" }} >
              <img src={loadingGif} alt="" />
            </div>
          ) : (
            <InfiniteScroll
              className={`${isMobile ? 'mx-0' : 'mx-0'}`}
              style={{ minHeight: "150vh" }}
              dataLength={SearchData.searchDataList.length}
              next={() => GetSearchDataPaged(pageNumber + 1, 7)}
              hasMore={SearchData.searchDataList.length < SearchData.totalCount}
              loader={
                <div className="d-flex justify-content-center ">
                  <img src={loadingGif} alt="" />
                </div>
              }
            >
              <div className='testContainer'>
                {SearchData.searchDataList.map((dt, i) => {
                  return <FoodCard key={i} foodItemData={dt} openingFrom="searchResult"></FoodCard>;
                })}
              </div>
            </InfiniteScroll>
          )
          }

          {/* <div id="container">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    pageCount={pageCount}
                    previousLabel="< "
                    renderOnZeroPageCount={null}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div> */}
        </div >
      }

      <Footer />
    </>
  );
}

export default SearchResult;
